<template>
    <div>
        <form @submit.prevent="getDataTable()">
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <label for="">Unidade solicitante</label>
                        <v-select v-model="unidadeSelecionada" placeholder="SELECIONE A UNIDADE SOLICITANTE" label="nome" :options="unidades"></v-select>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label for="">Procedimento</label>
                        <v-select v-model="procedimentoSelecionado" placeholder="SELECIONE O PROCEDIMENTO" label="nome" :options="procedimentos"></v-select>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-2">
                    <div class="form-group">
                        <label for="">Categoria da unidade</label>
                        <v-select v-model="categoriaUnidadeSelecionada" placeholder="SELECIONE A CATEGORIA" label="nome" :options="categorias"></v-select>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label for="">Paciente</label>
                        <select-paciente
                            :nome-paciente-recuperado="$store.state.filtrosRegulador.pacienteSelecionado.nome"
                            :regulador="true"
                            @setPacienteSelecionado="
                                paciente => {
                                    setPacienteSelecionado(paciente);
                                }
                            "
                        ></select-paciente>
                        <!-- <v-select v-model="pacienteSelecionado" @search="getPacientes" placeholder="SELECIONE O PACIENTE" label="nome" :options="pacientes"></v-select> -->
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label for="">Marcador</label>
                        <select-marcador
                            :nome-marcador-recuperado="$store.state.filtrosRegulador.marcadorSelecionado.name"
                            :regulador="true"
                            @setMarcadorSelecionado="
                                marcador => {
                                    setMarcadorSelecionado(marcador);
                                }
                            "
                        ></select-marcador>
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="form-group">
                        <label for="">&nbsp;</label>
                        <button type="submit" class="btn btn-block btn-default"><span class="fa fa-filter"></span> Filtrar</button>
                    </div>
                </div>
            </div>
        </form>
        <div class="row" style="margin-top:15px">
            <div class="col-sm-12 table-responsive">
                <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped">
                    <thead>
                        <tr role="row">
                            <th style="middle; width: 6%;">Código</th>
                            <th style="middle; width: 10%;">Data da solicitação (Tempo)</th>
                            <!-- <th style="middle; width: 4%;">Tipo Atendimento</th> -->
                            <th style="middle; width: 4%;">Tipo Consulta</th>
                            <th style="middle; width: auto;">
                                Solicitante
                                <span @click="sortByKey('H.nome')" class="icon-ordenacao">
                                    <i :class="filtros.ordem && filtros.coluna == 'H.nome' ? `fa fa-sort-alpha${'-' + filtros.ordem}` : 'fa fa-sort'"></i>
                                </span>
                            </th>
                            <th style="middle; width: auto;">
                                Procedimento(s)
                                <span @click="sortByKey('F.nome')" class="icon-ordenacao">
                                    <i :class="filtros.ordem && filtros.coluna == 'F.nome' ? `fa fa-sort-alpha${'-' + filtros.ordem}` : 'fa fa-sort'"></i>
                                </span>
                            </th>
                            <th style="middle; width: auto;">
                                Paciente
                                <span @click="sortByKey('A.nome')" class="icon-ordenacao">
                                    <i :class="filtros.ordem && filtros.coluna == 'A.nome' ? `fa fa-sort-alpha${'-' + filtros.ordem}` : 'fa fa-sort'"></i>
                                </span>
                            </th>
                            <th style="middle; width: auto;">Idade do paciente</th>
                            <th style="middle; width: auto;">Competência</th>
                            <th style="middle; width: auto;">Marcador</th>
                        </tr>
                    </thead>
                    <tbody>
                        <router-link role="row" tag="tr" :to="'/atendimentos/regulacao/solicitacao/' + item.id" class="even hand" v-for="item in dataTable.data" :key="item.id">
                            <td style="vertical-align: middle;">{{ item.id | formatarCodigo }} <i v-if="item.situacao == 6" class="fa fa-comments"></i></td>
                            <td style="vertical-align: middle;">{{ item.created_at | dataFormatadaHora }} ({{ item.created_at | diasDaData }})</td>
                            <!-- <td style= "vertical-align: middle;">{{ item.tipo_atendimento | tipoAtendimento }}</td> -->
                            <td>{{ item.tipo_consulta | tipoConsulta }}</td>
                            <td>{{ item.unidade }}</td>
                            <td style="vertical-align: middle;">
                                {{ item.codigo + " - " + item.procedimento }}
                            </td>
                            <td style="vertical-align: middle;">{{ item.paciente }}</td>
                            <td style="vertical-align: middle;">{{ item.data_nascimento | idade }}</td>
                            <td style="vertical-align: middle;">{{ item.data_competencia | mesPorExtenso }}</td>
                            <td>{{ item.marcador }}</td>
                        </router-link>
                    </tbody>
                </table>
                <div class="row">
                    <div class="col-sm-5">Mostrando {{ this.dataTable.from }} até {{ this.dataTable.to }} de {{ this.dataTable.total }} registros encontrados.</div>
                    <div class="col-sm-7" style="text-align:right">
                        <laravue-pagination :limit="5" :data="dataTable" v-on:pagination-change-page="getDataTable">
                            <span slot="prev-nav">&lt; Anterior</span>
                            <span slot="next-nav">Próximo &gt;</span>
                        </laravue-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios"; // Cliente para requisição http
import { SITUACAO_SOLICITACAO } from "@/constants";
import selectPaciente from "@/components/cadastros/pacientes/selectPaciente";
import selectMarcador from "@/components/cadastros/usuarios/selectMarcador";

export default {
    props: ["situacao"],
    data: () => ({
        filtros: {
            unidade_id: "",
            procedimento_id: "",
            paciente_id: "",
            categoria_unidade: "",
            usuario_solicitante_id: "",
            coluna: null,
            ordem: null
        },
        procedimentos: [],
        procedimentoSelecionado: {},
        // pacienteSelecionado: {},
        categoriaUnidadeSelecionada: {},
        // pacientes: [],
        unidades: [],
        categorias: [{ nome: "PÚBLICA (LOCAL)", id: 0 }, { nome: "MUNICÍPIO PACTUADO", id: 1 }, { nome: "PRIVADA", id: 2 }],
        unidadeSelecionada: {},
        dataTable: {}
    }),
    mounted() {
        this.filtros.unidade_id = this.$route.query.unidade_id ? this.$route.query.unidade_id : "";
        this.filtros.procedimento_id = this.$route.query.procedimento_id ? this.$route.query.procedimento_id : "";
        this.filtros.categoria_unidade = this.$route.query.categoria_unidade ? this.$route.query.categoria_unidade : "";
        this.filtros.usuario_solicitante_id = this.$route.query.usuario_solicitante_id ? this.$route.query.usuario_solicitante_id : "";
        this.filtros.paciente_id = this.$route.query.paciente_id ? this.$route.query.paciente_id : "";
        this.unidadeSelecionada = this.$store.state.filtrosRegulador.unidadeSelecionada;
        this.procedimentoSelecionado = this.$store.state.filtrosRegulador.procedimentoSelecionado;
        this.categoriaUnidadeSelecionada = this.$store.state.filtrosRegulador.categoriaUnidadeSelecionada;
        this.getDataTable();
        this.getProcedimentos();
        this.getUnidades();
    },
    methods: {
        sortByKey: function(field) {
            this.filtros.coluna = field;
            if (this.filtros.ordem == "asc") {
                this.filtros.ordem = "desc";
            } else {
                this.filtros.ordem = "asc";
            }
            this.getDataTable();
        },
        setPacienteSelecionado(paciente) {
            this.filtros.paciente_id = paciente.id;
            this.$store.state.filtrosRegulador.pacienteSelecionado = paciente;
        },
         setMarcadorSelecionado(marcador) {
            this.filtros.usuario_solicitante_id = marcador.id;
            this.$store.state.filtrosRegulador.marcadorSelecionado = marcador;
        },
        // getPacientes(search, loading) {
        //     if (search.length > 3) {
        //         loading(true);
        //         let config = this.$store.getters.getHeaderAuth;
        //         config.params.nome_paciente = search;
        //         axios
        //             .get(`${this.$store.state.serverURI}/api/cadastros/pacientes/getAll`, config)
        //             .then(response => {
        //                 this.pacientes = response.data;
        //                 loading(false);
        //             })
        //             .catch(error => {
        //                 this.$store.commit("throwException", error);
        //             });
        //     }
        // },
        getProcedimentos() {
            axios
                .get(`${this.$store.state.serverURI}/api/cadastros/procedimentos/getAll`, this.$store.getters.getHeaderAuth)
                .then(response => {
                    this.procedimentos = response.data;
                    this.$store.commit("TOGGLE_LOADING");
                })
                .catch(error => {
                    this.$store.commit("throwException", error);
                });
        },
        getUnidades() {
            axios
                .get(`${this.$store.state.serverURI}/api/cadastros/unidades/dataForSelect`, this.$store.getters.getHeaderAuth)
                .then(response => {
                    this.unidades = response.data;
                    this.$store.commit("TOGGLE_LOADING");
                })
                .catch(error => {
                    this.$store.commit("throwException", error);
                });
        },
        getDataTable(page) {
            if (typeof page === "undefined") {
                page = 1;
            }
            this.filtros.page = page;
            this.$router.push({ query: this.filtros });
            this.$store.commit("TOGGLE_LOADING");
            let config = this.$store.getters.getHeaderAuth;
            config.params = this.filtros;
            config.params.situacao = this.situacao;
            config.params.doDia = config.params.situacao.length == 1 && config.params.situacao[0] == SITUACAO_SOLICITACAO.REGULADA ? 1 : 0;
            axios
                .get(`${this.$store.state.serverURI}/api/atendimentos/getSolicitacoes`, config)
                .then(response => {
                    this.dataTable = response.data;
                    this.$store.commit("TOGGLE_LOADING");
                })
                .catch(error => {
                    this.$store.commit("throwException", error);
                });
        }
    },
    watch: {
        page: function(val) {
            if (val > 1) {
                this.getDataTable();
            }
        },
        procedimentoSelecionado: function(val) {
            if (val) {
                this.filtros.procedimento_id = val.id;
            } else {
                this.filtros.procedimento_id = null;
            }
            this.$store.state.filtrosRegulador.procedimentoSelecionado = val;
        },
        // pacienteSelecionado: function(val) {
        //     if (val) {
        //         this.filtros.paciente_id = val.id;
        //     } else {
        //         this.filtros.paciente_id = null;
        //     }
        // },
        unidadeSelecionada: function(val) {
            if (val) {
                this.filtros.unidade_id = val.id;
            } else {
                this.filtros.unidade_id = null;
            }
            this.$store.state.filtrosRegulador.unidadeSelecionada = val;
        },
        categoriaUnidadeSelecionada: function(val) {
            if (val) {
                this.filtros.categoria_unidade = val.id;
            } else {
                this.filtros.categoria_unidade = null;
            }
            this.$store.state.filtrosRegulador.categoriaUnidadeSelecionada = val;
        }
    },
    components: { selectPaciente, selectMarcador }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// tabelaSolicitacoes.vue?dd24de44